export default "__VITE_ASSET__M72gJWGG__"